<template>
  <div class="dea-school-data">
    <p class="dea-school-data__label dea-wishlist-product__editor dea-heading--upper__s">{{ label }}</p>
    <p class="dea-school-data__name-container">
      <span class="dea-school-data__name dea-heading--medium-xl">
        {{ name }}
      </span>
      <span class="dea-school-data__code">
        {{ code }}
      </span>
    </p>
    <p class="dea-school-data__address dea-heading--regular-xs">
      {{ address }}
    </p>
  </div>
</template>

<script>
/**
 *
 */
export default {
  name: "SchoolData",

  props: {
    name: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    code: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
  },
};
</script>
